import { z } from 'zod';
import { organizationIdSchema } from './organizations';
/**
 * Feature flags query schema (API querystring)
 *
 * `organizationId` is optional. When present the backend evaluates the flags
 * for that organization (same identity + `organization_id` trait the
 * server-side `is*Enabled` helpers use), so a caller can ask the server what
 * an org-scoped control should do instead of relying on the browser
 * Flagsmith SDK, whose identity overrides can disagree with the server
 * (KIR-4096). Callers must be members of the org or the route responds 403.
 */
export const featureFlagsQuerySchema = z.object({
    flagKeys: z.string().min(1),
    organizationId: organizationIdSchema.optional(),
});
/**
 * Feature flags input schema (client-side validation)
 */
export const featureFlagsInputSchema = z.object({
    flagKeys: z.array(z.string().regex(/^[a-z0-9_-]+$/)),
});
/**
 * Feature flags response schema
 */
export const featureFlagsResponseSchema = z.record(z.string(), z.boolean());
//# sourceMappingURL=feature-flags.js.map